import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { MemberGroupTypesState } from './types';

export const selectAdminMemberGroupTypes = (
    state: ApplicationRootState
): MemberGroupTypesState => state.admin.memberGroupTypes || initialState;

export const selectMemberGroupTypes = createSelector(
    selectAdminMemberGroupTypes,
    (state) => state.list
);

export const selectMemberGroupTypesOptions = createSelector(
    selectAdminMemberGroupTypes,
    (state): Array<{ label: string; value: number }> => {
        return (
            state.list.data?.map((memberGroupType) => ({
                label: memberGroupType.name,
                value: memberGroupType.id,
            })) ?? []
        );
    }
);
